import {User} from '../classes/user';

export class LocalStorage {

    private static _parentUser: User = null;

    static get userToken() {
        return this.getStorage('access_token');
    }

    static set userToken(token: string) {
        this.setStorage('access_token', token);
    }

    public static getParentUserToken() {
        return localStorage.getItem('parent_access_token');
    }

    static get user(): User {
        return JSON.parse(this.getStorage('user'));
    }

    static set user(user: User) {
        this.setStorage('user', JSON.stringify(user));
    }

    static get twoFaHash() {
        return this.getStorage('twoFaHash');
    }

    static set twoFaHash(twoFaHash: string) {
        this.setStorage('twoFaHash', twoFaHash);
    }

    public static localStorageGet(pKey) {
        return localStorage[pKey];
    }

    static logoutUser() {
        localStorage.removeItem('user');
        localStorage.removeItem('access_token');
        localStorage.removeItem('expire_access_token');
        localStorage.removeItem('token_date');
    }

    public static unsetParentUser() {
        localStorage.removeItem('parent_access_token');
        localStorage.removeItem('parent_user');
    }

    public static setParentUser(token, user) {
        localStorage.setItem('parent_access_token', token);
        localStorage.setItem('parent_user', JSON.stringify(user));
        this._parentUser = user;
    }

    private static getStorage(storageKey: string) {
        if (typeof localStorage !== 'undefined') {
            return localStorage.getItem(storageKey);
        }
        return null;
    }

    private static setStorage(storageKey: string, item?: string) {
        if (!item) {
            localStorage.removeItem(storageKey);
        } else {
            localStorage.setItem(storageKey, item);
        }
    }

    public static get parentUser(): User {
        return JSON.parse(localStorage.getItem('parent_user'));
    }

}
